export default __webpack_public_path__ + "static/media/logo.baa38dae.png";